import Request from 'request';

const ADMIN_API_URL = '/admin/api';
const ADMIN_PREFIX = 'admin/';

function isAbsolutePath(path) {
    return typeof path === 'string' && path.indexOf('/') === 0;
}

function stripAdminPrefix(path) {
    if (typeof path === 'string' && path.indexOf(ADMIN_PREFIX) === 0) {
        return path.substring(ADMIN_PREFIX.length);
    }
    return path;
}

export default {
    get(path, data) {
        if (isAbsolutePath(path)) {
            return Request.get(path, data);
        }

        return Request.get(ADMIN_API_URL, {
            ...(data || {}),
            path: stripAdminPrefix(path)
        });
    },

    post(path, data) {
        if (isAbsolutePath(path)) {
            return Request.post(path, data);
        }

        return Request.post(ADMIN_API_URL, {
            ...(data || {}),
            path: stripAdminPrefix(path)
        });
    },

    postJSON(path, data, timeout) {
        if (isAbsolutePath(path)) {
            return Request.postJSON(path, data, timeout);
        }

        return Request.postJSON(
            ADMIN_API_URL,
            {
                ...(data || {}),
                path: stripAdminPrefix(path)
            },
            timeout
        );
    }
};
